import React, { FC } from 'react';
import './MaintenanceBanner.scss';

const MaintenanceBanner: FC = () => {
    const maintenanceEnd = new Date('2026-02-01T05:59:59Z');
    const now = new Date();

    if (now > maintenanceEnd) {
        return null;
    }

    return (
        <div className="maintenance-banner" data-testid="maintenance-banner">
            We will be performing maintenance on Wednesday, February 4 at 11:30 AM CST. Users may experience some
            downtime.
        </div>
    );
};

export default MaintenanceBanner;
